import React, { useState, useEffect, useMemo } from "react";
import {
  createResource,
  getResource,
  deleteResource,
  createResumeResource,
} from "../redux/thunks/Resource";
import {
  getUserProfile,
  updateUserProfile,
  patchUserProfile,
  patchSetUserProfile,
} from "../redux/thunks/UserProfile";
import { PathName } from "../utils/routes";
import { useHistory } from "react-router-dom";
import { useMediaQuery } from "@mui/material";
import AlertBox from "../components/common/AlertBox";
import { AssessmentStatus } from "../utils/Constants";
import Input from "../components/sub-component/Input";
import { useDispatch, useSelector } from "react-redux";
import Button from "../components/sub-component/Button";
import ProgressBar from "../components/common/ProgressBar";
import { candidateActivation } from "../redux/thunks/Auth";
import AvtarBadge from "../components/dashboard/AvtarBadge";
import CustomTooltip from "../components/common/CustomTooltip";
import ProcessingIndicator from "../components/common/ProcessingIndicator";
import { getAssessment, takeOverSession } from "../redux/thunks/Assessment";
import { ReactComponent as CrossIcon } from "../assets/icons/candidate-assessment/x.svg";
import { ReactComponent as DeleteIcon } from "../assets/icons/candidate-assessment/trash.svg";
import { ReactComponent as UploadIcon } from "../assets/icons/candidate-assessment/upload.svg";
import { ReactComponent as AttachIcon } from "../assets/icons/candidate-assessment/attach.svg";
import { ReactComponent as UplaodICon } from "../assets/icons/Views/candidate/settings/upload.svg";
import { ReactComponent as ProfilePic } from "../assets/icons/Views/candidate/settings/profile-pic.svg";
import { ReactComponent as TestFuseWatermarkIcon } from "../assets/icons/candidate-assessment/Watermark.svg";

const GetImageURLFromId = ({ id, name }) => {
  const dispatch = useDispatch();
  const [resource, setResource] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      if (!id) return;
      setLoading(true);
      const dispatched = await dispatch(getResource({ id: id }));
      setLoading(false);

      if (dispatched.error) return;

      setResource(dispatched.payload);
    })();
  }, []);

  if (loading && id) {
    return (
      <div
        className="d-flex align-items-center justify-content-center"
        style={{ width: "96px", height: "96px" }}
      >
        <ProcessingIndicator className="small-indicator" />
      </div>
    );
  }

  return (
    <AvtarBadge
      size={"custom"}
      width={120}
      height={120}
      src={resource?.url}
      name={name}
    />
  );
};

function CandidateNameForm() {
  const history = useHistory();
  const dispatch = useDispatch();
  const isOnMobileScreen = useMediaQuery("(max-width: 767px)");
  const assessment = useSelector((state) => state.assessmentReducer);
  const searchParams = new URLSearchParams(window.location.search);
  const token = searchParams.get("invite_token");
  const invite_token = searchParams.get("invite_token");
  const assess_id = searchParams.get("assess_id");

  const [icon, setIcon] = useState();
  const [error, setError] = useState();
  const [alert, setAlert] = useState(null);
  const [lastName, setLastName] = useState("");
  const [firstName, setFirstName] = useState("");
  const [isloading, setIsLoading] = useState(true);
  const [processing, setProcessing] = useState(false);
  const [profileDetails, setProfileDetails] = useState();
  const [selectedFile, setSelectedFile] = useState(null);
  const [hidePassword, setHidePassword] = useState(true);
  const [selectedFileName, setSelectedFileName] = useState(null);
  const [hideConfirmPassword, setHideConfirmPassword] = useState(true);
  const { userProfileData, processing_patch_profile } = useSelector(
    (state) => state.userProfileReducer,
  );
  const resource = useSelector((state) => state.resourceReducer);

  useEffect(() => {
    (async () => {
      await dispatch(getUserProfile({}));
    })();
  }, []);

  const onChangeValueHandle = (e) => {
    setProfileDetails({ ...profileDetails, [e.target.name]: e.target.value });
  };

  const handleProfileImageUpload = async (event) => {
    if (resource.data?.id) {
      dispatch(deleteResource({ id: resource?.data?.id }));
    }
    const formData = new FormData();
    formData.append("file", event.target.files[0], event.target.files[0].name);
    const result = await dispatch(
      createResource({ data: formData, signal: null }),
    );
    setProfileDetails({
      ...profileDetails,
      image_id: result?.payload?.id,
    });
  };

  const handleFileUpload = async (event) => {
    if (event.target.files[0].size / 1024 / 1024 > 100) {
      setError("The uploaded file exceeded the max size limit (i.e 100mb)");
      return;
    }
    setError("");

    const formData = new FormData();
    formData.append("file", event.target.files[0], event.target.files[0].name);
    setSelectedFileName(event.target.files[0].name);
    setSelectedFile(event.target.files[0]);
    const dispatched = await dispatch(
      createResumeResource({ data: formData, signal: null }),
    );
    setProfileDetails({
      ...profileDetails,
      resume_id: dispatched?.payload?.id,
    });
  };

  const handleCancelUpload = () => {
    dispatch(deleteResource({ id: resource?.resume_data?.id }));
    setSelectedFileName(null);
    setSelectedFile(null);
  };

  useMemo(() => {
    setProfileDetails({ ...userProfileData });
  }, [userProfileData]);

  const handleChange = (name, value) => {
    if (name === "firstName") {
      setFirstName(value);
    } else if (name === "lastName") {
      setLastName(value);
    }
  };

  useEffect(() => {
    const fetchData = async (token) => {
      try {
        let accessToken = null;
        const disptached1 = await dispatch(
          candidateActivation({
            activation_token: token,
            route: `/resend-link?invite_token=${invite_token}&assess_id=${assess_id}`,
          }),
        );
        accessToken = disptached1.payload.data.access_token;
        const test = await dispatch(
          getUserProfile({ access_token: accessToken }),
        );

        if (
          test?.payload?.first_name !== "" &&
          test?.payload?.last_name !== ""
        ) {
          window.location.replace(`/dashboard/assessments/${assess_id}`);
          if (
            assessment?.current_assessment?.status === AssessmentStatus.FINISHED
          ) {
            window.location.replace(`/dashboard/assessments/${assess_id}`);
          } else {
            //
          }
        } else {
          //
        }
      } catch (error) {
        if (error?.message === "Invalid Token") {
          window.location.replace(
            `/resend-link?invite_token=${invite_token}&assess_id=${assess_id}`,
          );
        }
      }
    };
    if (token) {
      fetchData(token);
    } else {
      // window.location.replace(PathName.UNAVAILABLE_ASSESSMENT);
    }
  }, []);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsLoading(false);
      dispatch(getAssessment({ id: assess_id }));
    }, 4000);

    return () => clearTimeout(timeout);
  }, []);

  const handleSubmit = async (e, accessToken) => {
    setProcessing(true);
    e.preventDefault();
    try {
      const dispatched = await dispatch(
        patchSetUserProfile({
          data: {
            image_id: profileDetails?.image_id,
            first_name: profileDetails?.first_name,
            last_name: profileDetails?.last_name,
            email: profileDetails?.email,
            password: profileDetails?.password,
            resume_id: profileDetails?.resume_id,
          },
          access_token: accessToken,
        }),
      );
      const dispatched1 = await dispatch(
        takeOverSession({ assess_id: assess_id }),
      );
      const errorMessage = dispatched1?.error?.message;
      if (errorMessage === "Rejected") {
        window.location.replace("/unavailable-assessment");
        return;
      }
      setAlert(
        <AlertBox
          description="Profile updated successfully!"
          color="success"
          title="Success"
          onCloseAlert={() => {
            setAlert(null);
          }}
        />,
      );
      setProcessing(false);
      window.location.replace(`/dashboard/assessments/${assess_id}`);
    } catch (error) {
      setAlert(
        <AlertBox
          description={`Error occurred: ${error.message}`}
          color="danger"
          title="Error"
          onCloseAlert={() => {
            setAlert(null);
          }}
        />,
      );
      setProcessing(false);
    }
    window.location.reload();
  };

  useEffect(() => {
    (async () => {
      if (assessment?.current_assessment?.tenant?.image_id) {
        const imageResult = await dispatch(
          getResource({ id: assessment?.current_assessment?.tenant?.image_id }),
        );
        if (!imageResult.error) {
          setIcon(imageResult.payload.url);
        }
      }
    })();
  }, [assessment?.current_assessment?.tenant?.image_id]);

  return (
    <>
      {alert}
      {isloading || assessment?.loading_current_assess ? (
        <div
          style={{
            width: "100%",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <ProcessingIndicator />
        </div>
      ) : (
        <>
          {/* <div className="candidate-invite-main-container">
            <div className="candidate-invite-container">
              {assessment?.current_assessment?.tenant && (
                <div className="assessment-header">
                  {icon ? (
                    <img className="assessment-header-icon" src={icon} alt="" />
                  ) : (
                    <div className="assessment-header-icon-initial">
                      <span className="body-1 white">
                        {(
                          assessment?.current_assessment?.tenant?.company_name?.slice(
                            0,
                            2
                          ) || ""
                        ).toUpperCase()}
                      </span>
                    </div>
                  )}
                  <span className="headline-1 dark-100">
                    {assessment?.current_assessment?.tenant?.company_name}
                  </span>
                </div>
              )}
              <span className="headline-3 text-start">Enter Your Name</span>
              <span className="body-2 dark-50" style={{ marginTop: "-12px" }}>
                Please enter your first and last name for our records.
              </span>
              <form
                className="d-flex flex-column"
                style={{ width: !isOnMobileScreen ? "508px" : "100%" }}
                onSubmit={handleSubmit}
              >
                <div className="w-100 d-flex flex-column align-items-start">
                  <label
                    className="body-2 dark-50 mb-2"
                    style={{ marginLeft: "24px" }}
                  >
                    First Name
                  </label>
                  <Input
                    // placeholder="First Name"
                    onChange={(e) => handleChange("firstName", e.target.value)}
                    type={"text"}
                    value={firstName}
                    onBoardingInput
                    varrient={"primary"}
                  />
                </div>
                <div className="w-100 d-flex flex-column align-items-start mt-4">
                  <label
                    className="body-2 dark-50 mb-2"
                    style={{ marginLeft: "24px" }}
                  >
                    Last Name
                  </label>
                  <Input
                    // placeholder="Last Name"
                    onChange={(e) => handleChange("lastName", e.target.value)}
                    type={"text"}
                    value={lastName}
                    onBoardingInput
                    varrient={"primary"}
                  />
                </div>
                <div className="w-100 d-flex mt-4">
                  <Button
                    btn="ragular-btn"
                    varrient="primary"
                    textClass="body-1"
                    processing={processing}
                    type={"submit"}
                    title={"Save and Continue"}
                    style={{ width: "100%", height: "40px" }}
                  />
                </div>
              </form>
            </div>
          </div> */}
          {/* <div className="candidate-assessment-flow-container">
            <div className="candidate-assment-flow-wrapper"> */}
          <div
            className="assessment-info-dialog-box-container"
            style={{ maxWidth: "100%" }}
          >
            <div className="candidate-profile-container">
              <div className="candidate-profile-pic-detail">
                <span className="subtitle-1 dark-100">{"Profile Setup"}</span>
                <div className="candidate-profile-pic">
                  <div
                    style={{
                      width: "120px",
                      height: "120px",
                      position: "relative",
                    }}
                  >
                    {profileDetails?.image_id ? (
                      <>
                        {profileDetails?.image_id instanceof File ? (
                          <AvtarBadge
                            size={"custom"}
                            width={120}
                            height={120}
                            src={URL.createObjectURL(profileDetails?.image_id)}
                          />
                        ) : (
                          <GetImageURLFromId id={profileDetails?.image_id} />
                        )}
                      </>
                    ) : (
                      <div className="profile-img">
                        <input
                          type="file"
                          className="position-absolute pointer"
                          style={{
                            left: "0px",
                            width: "120px",
                            height: "120px",
                            opacity: "0",
                          }}
                          name="profile_picture"
                          onChange={handleProfileImageUpload}
                        />
                        <ProfilePic
                          className="profile-img-upload-icon2"
                          style={{ width: "64px", height: "64px" }}
                        />
                        <UplaodICon
                          className="profile-img-upload-icon"
                          style={{ width: "44px", height: "44px" }}
                        />
                      </div>
                    )}
                  </div>
                  <div
                    className="d-flex flex-column"
                    style={{ gap: "12px", marginTop: "12px" }}
                  >
                    <div className="relative pointer align-self-start">
                      {processing_patch_profile ? (
                        <Button
                          btn="ragular-btn"
                          varrient="primary"
                          title=""
                          style={{ width: "187px", height: "41px" }}
                          processing={processing_patch_profile}
                        />
                      ) : (
                        <span
                          className="w-100 pointer"
                          style={{
                            padding: "12px 24px 12px 24px",
                            borderRadius: "50px",
                            background: "#121216",
                            color: "white",
                          }}
                        >
                          Upload Profile Picture
                        </span>
                      )}
                      <input
                        type="file"
                        className="position-absolute pointer"
                        style={{
                          left: "150px",
                          width: "190px",
                          opacity: "0",
                        }}
                        name="profile_picture"
                        onChange={handleProfileImageUpload}
                      />
                    </div>
                    <span className="body-2 dark-50 mt-2">
                      JPG, JPEG & PNG formats are allowed
                    </span>
                  </div>
                </div>
              </div>
              <div className="candidate-profile-details">
                <span className="subtitle-1 dark-100">
                  {"General Settings"}
                </span>
                <div className="candidate-profile-other-details">
                  <div className="candidate-profile-edit-detail">
                    <Input
                      varrient={"primary"}
                      className="input body-3 primary-input"
                      // placeholder="John"
                      title={"First Name"}
                      isRequired
                      value={profileDetails?.first_name}
                      name={"first_name"}
                      onChange={onChangeValueHandle}
                    />
                  </div>
                  <div className="candidate-profile-edit-detail">
                    <Input
                      varrient={"primary"}
                      className="input body-3 primary-input"
                      // placeholder="Doe"
                      title={"Last Name"}
                      isRequired
                      value={profileDetails?.last_name}
                      name={"last_name"}
                      onChange={onChangeValueHandle}
                    />
                  </div>
                  <div className="candidate-profile-edit-detail">
                    <Input
                      readOnly
                      varrient="primary"
                      className="input body-3 primary-input"
                      // placeholder="johndoe@gmail.com"
                      title={"Email"}
                      isRequired
                      value={profileDetails?.email}
                      name={"email"}
                      onChange={onChangeValueHandle}
                    />
                  </div>
                </div>
                <div className="candidate-profile-other-details">
                  <div className="candidate-profile-edit-detail">
                    <Input
                      name={"password"}
                      title={"Password"}
                      // placeholder="********"
                      varrient="password-input-with-title"
                      className="input body-3 primary-input"
                      isRequired
                      enableRevealIcon={true}
                      type={hidePassword ? "password" : "text"}
                      revealPasswordClick={() => setHidePassword(!hidePassword)}
                      value={profileDetails?.password}
                      onChange={onChangeValueHandle}
                    />
                  </div>
                  <div className="candidate-profile-edit-detail">
                    <Input
                      name={"confirm_password"}
                      title={"Confirm Password"}
                      // placeholder="********"
                      varrient="password-input-with-title"
                      className="input body-3 primary-input"
                      isRequired
                      enableRevealIcon={true}
                      type={hideConfirmPassword ? "password" : "text"}
                      revealPasswordClick={() =>
                        setHideConfirmPassword(!hideConfirmPassword)
                      }
                      value={profileDetails?.confirm_password}
                      onChange={onChangeValueHandle}
                    />
                  </div>
                </div>
                <>
                  {resource?.resume_upload_percentage > 0 ? (
                    <div className="uploaded-doc-container">
                      <AttachIcon />
                      <div
                        className="d-flex flex-column align-items-start"
                        style={{ width: "calc(100% - 36px)", gap: "8px" }}
                      >
                        <div className="w-100 d-flex flex-row align-items-center justify-content-between">
                          <div className="w-100 d-flex flex-column align-items-start">
                            <span className="body-2 dark-100">
                              {resource.processing_resume
                                ? selectedFileName
                                : resource?.resume_data?.name}
                            </span>
                            <span className="body-2 dark-100">
                              {resource.processing_resume
                                ? (selectedFile?.size / 1024).toFixed(1)
                                : (resource?.resume_data?.size / 1024).toFixed(
                                    1,
                                  )}{" "}
                              kb
                            </span>
                          </div>
                          {resource.processing_delete ? (
                            <ProcessingIndicator className="medium-indicator" />
                          ) : resource?.resume_upload_percentage < 100 ? (
                            <></>
                          ) : (
                            <DeleteIcon
                              cursor="pointer"
                              onClick={handleCancelUpload}
                            />
                          )}
                        </div>
                        <ProgressBar
                          varrient={"progress-with-upload-doc"}
                          value={resource?.resume_upload_percentage}
                        />
                      </div>
                    </div>
                  ) : (
                    <>
                      <div className="text-upload-doc-container">
                        <div
                          className="d-flex flex-column align-items-center pointer"
                          style={{
                            position: "relative",
                            minWidth: "260px",
                            height: "90px",
                            gap: "12px",
                          }}
                        >
                          <div
                            className="d-flex flex-column align-items-center"
                            style={{ width: "30px", height: "30px" }}
                          >
                            <UploadIcon />
                          </div>
                          <span className="subtitle-2 dark-100">
                            Drag & drop your resume here or click to upload.
                          </span>
                          <span className="body-2 dark-50">
                            pdf, csv, txt, or doc (max size 100mb)
                          </span>
                          <input
                            className="pointer"
                            style={{
                              position: "absolute",
                              left: 0,
                              right: 0,
                              width: "100%",
                              height: "100%",
                              opacity: 0,
                            }}
                            type="file"
                            disabled={resource.processing_resume}
                            accept=".pdf, .csv, .txt, .doc, .docx"
                            onChange={handleFileUpload}
                          />
                        </div>
                      </div>
                      {error && (
                        <div className="uploaded-doc-container align-items-center">
                          <AttachIcon />
                          <span className="body-2 danger-text">{error}</span>
                        </div>
                      )}
                    </>
                  )}
                </>
                <div className="w-100 d-flex justify-content-end">
                  <CustomTooltip
                    text={
                      !profileDetails?.first_name ||
                      !profileDetails?.last_name ||
                      !profileDetails?.password ||
                      !profileDetails?.confirm_password ||
                      !profileDetails?.resume_id
                        ? "Please fill First Name, Last Name, Password and Confirm Password field and Upload Resume mandatory to proceed next"
                        : ""
                    }
                  >
                    <Button
                      btn="ragular-btn"
                      varrient="primary"
                      title={"Next"}
                      disabled={
                        !profileDetails?.first_name ||
                        !profileDetails?.last_name ||
                        !profileDetails?.password ||
                        !profileDetails?.confirm_password ||
                        !profileDetails?.resume_id
                      }
                      className="btn-md align-self-end"
                      processing={
                        processing_patch_profile || resource.processing_resume
                      }
                      onClick={handleSubmit}
                    />
                  </CustomTooltip>
                </div>
              </div>
            </div>
          </div>
          <div className="watermark mt-3">
            <TestFuseWatermarkIcon style={{ height: "50px" }} />
          </div>
        </>
      )}
    </>
  );
}

export default CandidateNameForm;
